import Component from 'flarum/common/Component';

export default class CaptchaComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.style = this.attrs.style;
  }

  view() {
    return (
      <img style={this.style} className="u2diCaptcheImage" src="assets/extensions/ziiven-u2di/captcha.php" onclick={(e)=>{
        let id = Math.random();
        $(e.target).attr('src', 'assets/extensions/ziiven-u2di/captcha.php?id='+id);
      }} />
    );
  }
}